import { Cross } from "lucide-react";

export function Logo({ compact = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="app-header-logo">
      <div className="relative flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-sky-600 to-emerald-600 shadow-md shadow-sky-600/20">
        <Cross className="h-5 w-5 text-white" strokeWidth={2.5} />
      </div>
      {!compact && (
        <div className="leading-tight">
          <div className="font-heading text-lg font-extrabold tracking-tight text-slate-900 dark:text-white">
            C&amp;A <span className="text-sky-600 dark:text-sky-400">Pharmacy</span>
          </div>
          <div className="text-[10px] font-semibold uppercase tracking-widest text-slate-400">
            Knowledge Portal
          </div>
        </div>
      )}
    </div>
  );
}
